import { cn } from "@/lib/utils"

function Skeleton({ className, ...props }) {
  return (
    <div className={cn("animate-pulse rounded-md bg-slate-200", className)} {...props} />
  );
}

function SkeletonCard() {
  return (
    <div className="border rounded-md p-4 space-y-3 bg-white">
      <Skeleton className="h-3 w-1/4" />
      <Skeleton className="h-5 w-3/4" />
      <div className="flex gap-2">
        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-4 w-20" />
      </div>
      <Skeleton className="h-3 w-1/2" />
    </div>
  );
}

function SkeletonRow({ cols = 4 }) {
  return (
    <div className="flex items-center gap-3 py-3 border-b">
      {Array.from({ length: cols }).map((_, i) => (
        <Skeleton key={i} className={`h-4 ${i === 0 ? "w-1/4" : "flex-1"}`} />
      ))}
    </div>
  );
}

export { Skeleton, SkeletonCard, SkeletonRow }
